import { render } from "./Blog3View.vue?vue&type=template&id=27b003c9"
import script from "./Blog3View.vue?vue&type=script&lang=js"
export * from "./Blog3View.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__